import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import CustomButton from "components/CustomButton";
import {FormattedMessage} from "react-intl";
import {useSnackbar} from "notistack";

import MobileIconButton from "./MobileView/components/MobileIconButton";

import {DateRangePickerContext} from "contexts/DateRangePickerContext";

import {downloadExportLineItem} from "api/order/export";

ExportLineItemsButton.propTypes = {
    compact: PropTypes.bool
};

const ExportIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.66634 3.99999H9.33301C10.6663 3.99999 10.6663 3.33333 10.6663 2.66666C10.6663 1.33333 9.99967 1.33333 9.33301 1.33333H6.66634C5.99967 1.33333 5.33301 1.33333 5.33301 2.66666C5.33301 3.99999 5.99967 3.99999 6.66634 3.99999Z" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9.33333 14.6667H6C2.66667 14.6667 2 13.3333 2 10.6667V6.66666C2 3.62666 3.11333 2.79999 5.33333 2.67999" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.667 2.67999C12.887 2.79999 14.0003 3.61999 14.0003 6.66666V9.99999" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10 12.6667V10.6667H12" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13.9997 14.6667L10.0264 10.6933" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
);

function ExportLineItemsButton({compact = false}) {
    const {startDate, endDate} = useContext(DateRangePickerContext);
    const {enqueueSnackbar} = useSnackbar();

    async function handleClick() {
        try {
            await downloadExportLineItem(startDate, endDate);

            enqueueSnackbar(<FormattedMessage id="picking.order.list.export.success" />, {variant: 'success'});
        } catch {
            enqueueSnackbar(<FormattedMessage id="list.error" />, {variant: 'error'});
        }
    }

    return (
        compact ? (
            <MobileIconButton onClick={handleClick}>
                <ExportIcon />
            </MobileIconButton>
        ) : (
            <CustomButton color={'default'} variant={'outlined'} onClick={handleClick}>
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    <FormattedMessage id='oms.order.list.export.lineItems' />
                    <ExportIcon />
                </div>
            </CustomButton>
        )
    );
}

export default ExportLineItemsButton;
